module.exports = __webpack_public_path__ + "static/media/student-summary-contender-prev.5fefdd3d.png";